import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { DtoTicketTakerEvent } from 'src/app/core/services/api/models/DtoTicketTakerEvent';

export interface AvailableEventsState extends EntityState<DtoTicketTakerEvent> {}
export const availableEventsAdapter = createEntityAdapter<DtoTicketTakerEvent>({
  selectId: (e) => e.TicketConfiguration.ID,
});
